import React from "react";
import { WarningMessage } from "sprint-common-web";

import { useCloudFileDetails } from "../../common/useCloudFileDetails";

export const CloudFileWarningSection = (): JSX.Element => {
    const { data: cloudFileDetails } = useCloudFileDetails();

    if (cloudFileDetails?.isBeingProcessed) {
        return (
            <WarningMessage message="Cloud file is being processed right now. New trimmed version will be ready soon." />
        );
    }

    return <></>;
};
